<template>
    <div class="row">
        <div class="col-xs-11">
            <div class="form-group" id="eligibility-form">
                <vue-form
                    :form-config="formConfig"
                    :form-data="{}"
                    :actions="formActions"
                    @eligibility-search="handleEligibilitySearch"
                ></vue-form>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {

    props: {
        formConfig: {
            required: true,
            type: Object
        }
    },

    data(){
        return {
            searchValue: "",
            formActions: [
                {
                    name: 'eligibility_search',
                    label: 'Search',
                    action: 'eligibility-search'
                },
            ]
        }
    },
    methods: {
        handleEligibilitySearch(data) {
            const userData =  Object.assign({}, data);
            // Make API Request to filter the search results
            axios.get('/api/eligibility/search', {
                params: userData
            }).then((res) => {
                this.$emit('filter-list', res.data);
            }).catch((error) => {
                window.notify.apiError(error);
            });
        },
    }
}
</script>
<style>
#eligibility-form .vue-form .form-group {
    margin: 0px;
}
#eligibility-form .vue-form .form-group .form-control {
    margin: 0px;
}
#eligibility-form .vue-form .form-group .form-control-label {
    margin: 5px 0px;
}
</style>
